export enum RunStatusEnum {
  Preparing = 0,
  Published = 1,
  Republished = 2,
  ClosedFromPublished = 3,
  Archived = 4,
  ClosedFromRepublished = 5,
  Revise = 6,
  All = 99,
}
